import { StoreService } from '../core';
import { BaseStore, GenericData, Cycle, SessionItem, eItem } from '../shared';

export class BaseCursus extends BaseStore {

  constructor(
    protected store: StoreService,
  ) {
    super(store);
  }

  protected filterCursus(list: GenericData<Cycle>[], yearP: number, monthP: number): GenericData<Cycle>[] {
    let result: GenericData<Cycle>[] = [];
    let ms: Cycle[] = [];
    for (let n: number = 0; n < list.length; n++) {
      const t: Cycle[] = list[n].listFils.filter((e: Cycle): boolean => e.year === yearP && e.month === monthP);
      if (t.length > 0)
        ms = ms.concat(t);
    }
    if (ms.length === 0) { this.store.warning(this.store.getTrad('cyclelist2')); }
    result = this.store.convertList<Cycle>(ms, 2);
    return result;
  }

  protected setCycle(c: Cycle): void {
    let item: SessionItem | null = super.getSession(eItem.CYCLE);
    if (!item)
      item = new SessionItem(eItem.CYCLE);

    item.id = c.Ident;
    item.desc = c.ValueDOS;
    item.jsData = JSON.stringify(c);
    this.store.AddDataSession(item);
  }
}
